import styled from 'styled-components';

const StyledLoading = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: 2px;
  animation: shimmer 3s infinite;
  background: linear-gradient(to right, #eff1f3 5%, #e2e2e2 50%, #eff1f3 95%);
  background-size: 500px 100%;

  @keyframes shimmer {
    0% {
      background-position: -500px 0;
    }
    100% {
      background-position: 500px 0;
    }
  }
`;

export default StyledLoading;
